import { OctreeNode } from './OctreeNode';

export class Octree {
  id = '';

  isVisible = true;

  url: string;

  material: string;

  root: OctreeNode;

  nodesToShow?: Set<string>;

  totalNumPoints: number;

  constructor(url: string, root: OctreeNode, totalNumPoints: number) {
    this.url = url;
    this.material = '';
    this.root = root;
    this.totalNumPoints = totalNumPoints;
  }
}
